import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class HTHGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WIN_COUNT_UP_RED = "NumberWinCountUpRed";
    static BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER = "SymbolMultiplier";
    static BITMAP_FONT_XNUDGE_MULTIPLIER = "XnudgeMultiplier"

    public static MAIN_GAME_BACKGROUND: string = "MainBG";
    public static FS_BACKGROUND: string = "FreespinBG";
    public static REEL_BG: string = "ReelBG";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP_RED, "fonts/bitmapfonts/NumberWinCountUpRed.fnt"),
                    new BitmapFontAsset(HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER, "fonts/bitmapfonts/SymbolMultiplier.fnt"),
                    new BitmapFontAsset(HTHGameAssets.BITMAP_FONT_XNUDGE_MULTIPLIER, "fonts/bitmapfonts/XnudgeMultiplier.fnt"),
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                ],
                animations: {}
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("EB", "spine/EB.json"),
                    new SpineAsset("SC", "spine/scatter.json"),
                    new SpineAsset("SS", "spine/superScatter.json"),
                    new SpineAsset("SA", "spine/safe.json"),
                    new SpineAsset("W", "spine/wild.json"),
                    new SpineAsset("XN", "spine/xnudge.json"),
                    new SpineAsset("RW", "spine/RW.json"),
                    new SpineAsset("XS", "spine/XS.json"),
                    new SpineAsset("XW", "spine/XW.json"),
                    new SpineAsset("XW_bg", "spine/XW_bg.json"),
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("blast", "spine/blast.json"),
                    new SpineAsset("FS_meter", "spine/FS_meter.json"),
                    new SpineAsset("BigWins", "spine/Bigwin.json"),
                    new SpineAsset("MaxWin", "spine/Maxwin.json"),
                    new SpineAsset("MaxWinFire", "spine/maxwin_fire.json"),
                    new SpineAsset("BigwinTransition", "spine/bigwin_transition.json"),
                    new SpineAsset("maxwinSymbol", "spine/Maxsymbol.json"),
                    new SpineAsset("+2HellSpins", "spine/WonSpins.json"),
                    new SpineAsset("SpinOutReelFire", "spine/Reelfire.json"),
                    new SpineAsset("fsOutro", "spine/FS_Outro.json"),
                    new SpineAsset("fsIntro", "spine/FS_Intro.json"),
                    new SpineAsset("totalWinBg", "spine/splash_won_bg.json"),
                    new SpineAsset("mainBG", "spine/basegameBG.json"),
                    new SpineAsset("fsBG", "spine/freespinBG.json")


                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                ],
                animations: {
                    "ReelBG": "ReelBG",
                    "reelFrame": "Reel_frame",
                    "RTP_sign": "extraspin/RTP_sign",
                    "Extra_Spin_Screen": "extraspin/Extra_Spin_Screen",
                    "flame": "RWTrailParts/20x20"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json")
                ],
                animations: {
                    "xsplitLightEffect": "nudge_light",
                    "winHighlight": "WinHighlighter/WinHighlighter_",
                    "winBlast": "WinBlast/WinBlast_",
                    "removalWildBlastEffect": "RW_Blast/RW_Blast_",
                    "removalSymbolTrail": "winTrail/fire_",
                    "xSplitHighlightEffect": "Fire_xsplit_symbols/fire",
                    "openedEBHighlight": "Fire_wild/fire",
                    "avaSplitEffect": "RW_Blast/AvaSplitHighlight_",
                    "splitLight": "splitlight",
                    "sReelAnticipationSiren": "Scatter_Anticipation/siren_",
                    "scatterReelAreaAnticipation": "Scatter_Anticipation/reel_",
                    "scatterLightBG": "reel_plate",
                    "superScatterConvertEffect": "FS_Safe_Transition/FS_Safe_Transition_",
                    "removalSymConvertEffect": "RemovalSymbol_Blast/RemovalSymbol_Blast_",
                    "removalSymBlastEffect": "Symbol_removal/removal_",
                    "bigWinExplosion": "flameEffect/Flame 10_",
                    "maxWinFireEffect": "wincapMultiplierEffect/Comp ",
                    "countUpSparkEffect": "sparkEffect/sparks",
                    "maxwinShine": "Shine_maxwin/shine_numbers_Maxwin",
                    "introMask": "FS_Intro_Mask",
                    "outroMaskBad": "FS_Bad_outro",
                    "outroMaskGood": "FS_Good_outro",

                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                ],
                animations: {
                    "gameLogo": "intro_logo_small"
                }
            },
            {
                name: "symbolsNoTrim",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsNoTrim0", "sheets/symbolsNoTrim/symbolsNoTrim0.json"),
                ],
                animations: {}
            },
            {
                name: "mainJpegHigh",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.MEDIUM],
                assets: [
                    new TextureAsset("mainJpegHigh0", "sheets/mainJpegHigh/mainJpegHigh0.json"),
                    new TextureAsset("mainJpegHigh1", "sheets/mainJpegHigh/mainJpegHigh1.json"),
                ],
                animations: {}
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}